import {backAdmin} from "../axios";

export const coreApi = [
    {url: `${backAdmin}/locales`, name: 'core.locales', method: 'get'},
]